import { useEffect, useRef, useState } from "react";
import { ChangeAlertCallbackType } from "../../../Root";
import { CrmService } from "../../../../services/CrmService";
import { useCRMFunction } from "../../../customwidgets/leads-crm/hooks/useCRMFunction";
import moment from "moment";
moment.locale("es");

export const useCRMAddRegister = (changeAlert: ChangeAlertCallbackType, onClose: Function, getData: Function, getLeadByUuid?: Function, crmContactFlow?: string) => {
    const { handleCatalog } = useCRMFunction(changeAlert);
    
    const crmService = useRef<CrmService>();
    const [store, setStore] = useState({});
    const [form, setForm] = useState({});
    const [zPos, setZPos] = useState(45);
    const [isValid, setIsValid] = useState(true);
    const [loading, setLoading] = useState(true);
    const [tabActive, setTabActive] = useState('create');
    const [error, setError] = useState("");
    const [companyGroups, setCompanyGroups] = useState([]);
	const [segments, setSegments] = useState(null);
    const [groupUuid, setGroupUuid] = useState(false);
    const [initialGroup, setInitialGroup] = useState(null);

    const agent = localStorage.session ? JSON.parse(localStorage.session) : {};
    const config = localStorage.config ? JSON.parse(localStorage.config) : {};

    const storeData = async (section, lead, crmType, platformData, platformInfo) => {
        let d = store;
        d["section"] = section;
        d["platform"] = crmType;
        d["platformData"] = platformData;
        d["platformInfo"] = platformInfo;
        setStore(d);
        setLoading(false);
        setTabActive(lead ? "update" : "create" )

        switch (section) {
            case 'contact':
                setForm({
                    ...form,
                    general: {
                        gname: '', lname: '', email: '',
                        phone: {phone: '', phone_code: '+52'},
                    }, app_uuid: '', origin_platform: '', status: '', crmContactFlow: config['crmOutbound'] ? 'crmOutbound' : 'crmInbound'
                })
                break;
            case 'company':
                setForm({
                    ...form,
                    general: {
                        company_name: '', account_type: '', onboarding_email: '', company_group: '', segment: ''
                    }, app_uuid: '', origin_platform: ''
                })
                break;
            case 'company_group':
                setForm({...form, group_name: ''})
                break;
        }

        lead && setForm(lead);
        section === 'company' && onGetCompanyGroup() && await getCatalog('customer_segments', [{ 'metadata.external.origin': 'afb' }]);
    };

    const onGetCompanyGroup = async () => {
        setLoading(true);
        setZPos(1);

        let request = { filters: {all: true} };
        
        const response = await crmService.current.leadCrmGroupList(request);
        if (response['data']?.response === 'OK') {
            setCompanyGroups(response['data']['widget'][0]['data']['content']);
        } else {
            changeAlert(true, 'error', response['message'] || response['data'].message || 'Error al consultar grupos de empresa.');
        }
        setLoading(false);
        setZPos(45);
    };
    
    const getCatalog = async (type: string, metadata?: Array<any>) => {
        let resp = await handleCatalog(type, metadata);
        if(resp){
            setSegments(resp);
        }
        setLoading(false);
    };

    const onCreate = async () => {
        setLoading(true);
        setZPos(1);

        let req = { data: form };

        let service = "";
        if (store["section"] === "company") {
            service = "leadCrmCreate";
            req["data"]["low_funnel"] = "opportunity";
            req["data"]["status"] = form["result"] ? "leftOnboarding" : "lead";
        } else if(store["section"] === "contact"){
            service = "leadContactCrmCreate";
            req["data"]["status"] = "new";
        } else {
            service = "leadCrmGroupCreate";
            req["data"]["status"] = "enabled";
            if(form["charge_fee"]){
                req["data"]["charge_fee"] = Number(form["charge_fee"]);
            }
        }

        if(form["charge_fee"]){
            form["charge_fee"] = Number(form["charge_fee"])
        }

        req["data"]["agent"] = {
            uuid: agent["uuid"],
            email: agent["email"],
            name: agent["name"],
        };

        const response = await crmService.current[service](req);
        if (response["data"]?.response === "OK") {
            if(groupUuid){
                let payload = {
                    uuid: response["data"]["content"]["uuid"],
                    company_name: form["general"]["company_name"]
                }
                onAddCompanyGroup(payload, 'create');
            } else {
                setLoading(false);
                onClose();
                getData(store["section"], null, crmContactFlow);
            }
        } else {
            setLoading(false);
            setZPos(45);
            changeAlert(true, "error", response["message"] || response["data"].message || "Error al consultar servicio");
        }
    };

    const onUpdate = async () => {
        if (store['section'] !== 'company_group') {
            setLoading(true);
            setZPos(1);

            if(!form["agent"]["email"]){
                form["agent"]["uuid"] = agent["uuid"]
                form["agent"]["email"] = agent["email"]
                form["agent"]["name"] = agent["name"]
            }
            
            if(form["charge_fee"]){
                form["charge_fee"] = Number(form["charge_fee"])
            }

            let service = store['section'] === 'company' ? 'leadCrmUpdate' : 'leadContactCrmUpdate'
            let request = { data: form };
            
            const response = await crmService.current[service](request);
            if (response['data']?.response === 'OK') {
                if(groupUuid){
                    let payload = {
                        uuid: form["uuid"],
                        company_name: form["general"]["company_name"]
                    }
                    onAddCompanyGroup(payload, 'update');
                } else {
                    cleanForm()
                    onClose();
                    getLeadByUuid(form['uuid'], store['section'], store['platform'], store['platformData'], store['platformInfo']);
                    changeAlert(true, 'success', 'El registro se actualizó con éxito');
                }
            } else {
                setLoading(false);
                setZPos(45);
                changeAlert(true, 'error', response['message'] || response['data'].message || 'Error al actualizar el registro');
            }
        } else {
            return onUpdateGroupDetail();
        }
    };

    const onUpdateGroupDetail = async () => {
        setLoading(true);
        setZPos(1);

        let request = {
            uuid: form["uuid"],
            group_name: form["group_name"],
            charge_fee: Number(form["charge_fee"]),
            partner_list: form["partner_list"]
        };
        
        const response = await crmService.current.leadCrmGroupUpdate({data: request});
        if (response['data']?.response === 'OK') {
            cleanForm()
            setLoading(false);
            onClose();
            getData(store["section"], null, crmContactFlow);
            changeAlert(true, 'success', 'El registro se actualizó con éxito');
        } else {
            setLoading(false);
            setZPos(45);
            changeAlert(true, 'error', response['message'] || response['data'].message || 'Error al actualizar el registro');
        }
    };

    const onAddCompanyGroup = async (req, action) => {
        let request = {
            uuid: groupUuid,
            partner_list: req
        };
        
        if (initialGroup) {
            await crmService.current.leadCrmGroupUpdate({data: initialGroup});
        }
        const response = await crmService.current.leadCrmGroupAdd({data: request});
        if (response['data']?.response === 'OK') {
            if (action === "update") {
                cleanForm()
                onClose();
                getLeadByUuid(form['uuid'], store['section'], store['platform'], store['platformData'], store['platformInfo']);
                changeAlert(true, 'success', 'El registro se actualizó con éxito');
            } else {
                setLoading(false);
                onClose();
                getData(store["section"], null, crmContactFlow);
            }
        } else {
            setLoading(false);
            setZPos(45);
            changeAlert(true, 'error', response['message'] || response['data'].message || 'Error al actualizar el registro');
        }
    };

    const onHandleChange = (key1, key2, key3 = null, e) => {
        let f = form;
        let g = initialGroup;
        let value = e["target"] ? e["target"]["value"] : e["props"]["value"];
        
        if (key2.includes("email")) {
            value = value.trim();
        }

        if (key2 === "company_group" && value) {
            let item = companyGroups.filter((i) => i.uuid === value)[0];
            if(form["general"]["company_group"] && tabActive === "update"){
                if (!g) {
                    let oldUuid = companyGroups.filter((i) => i.uuid === form["general"]["company_group"]);
                    if (oldUuid.length > 0) {
                        let cleanPartnerList = {
                            uuid: oldUuid[0]['uuid']
                        }
                        cleanPartnerList['partner_list'] = oldUuid[0].partner_list.filter((j) => j.uuid !== form["uuid"]);
                        g = cleanPartnerList;
                    }
                } else if(g["uuid"] === item['uuid']){
                    g = null;
                }
            }
            setGroupUuid(item["uuid"]);
            f["charge_fee"] = item["charge_fee"];
        }

        if (key3) {
            f[key1] ?
                f[key1][key2]
                ?
                f[key1][key2][key3] = key3 === 'phone_code' ? `+${value}` : value
                :
                f[key1][key2] = {[key3]: key3 === 'phone_code' ? `+${value}` : value}
            :
            f[key1] = {[key2]: {[key3]: key3 === 'phone_code' ? `+${value}` : value}}
            
            if (!f[key1][key2]["phone_code"]) {
                f[key1][key2]["phone_code"] = "+52";
            }
        } else if (key2 && key1) {
            let val = key1 === "revenue" ? Number(value) : value;
            f[key1] ? f[key1][key2] = val : f[key1] = {...form[key1], [key2]: val}
        } else if(key1){
            f[key1] = value;
        } else if(!key1 && key2){
            f[key2] = value;
        }


        store["section"] !== "company_group" ? validateForm(f) : validateCompanyGroup(f);
        setInitialGroup(JSON.parse(JSON.stringify(g)));
        setForm(JSON.parse(JSON.stringify(f)));
    };

    const validateForm = (f) => {
        const allFieldsFilled = 
        Object.values(f.general).every((field) => {
            if (typeof field === 'object') {
                return Object.values(field).every((value) => String(value).trim() !== '');
            }
            return String(field).trim() !== '';
        }) && 
        Object.values(f).filter(value => typeof value === 'string').every(value => String(value).trim() !== '');
        
        setIsValid(!allFieldsFilled);

        if (store["section"] === "company") {
            validateRevenue(f, allFieldsFilled)
        }
    };

    const validateRevenue = (f, status) => {
        if(status && f["revenue"] && (f["revenue"]["nMAB"] || f["revenue"]["nMAW"] || f["revenue"]["nMAD"])){
            setError("")
            setIsValid(false);
        } else {
            setError("Recuerde que debe completar al menos un campo de Revenue.");
            setIsValid(true);
        }
    };

    const validateCompanyGroup = (f) => {
        if(f["group_name"]){
            setError("");
            setIsValid(false);
        } else {
            setIsValid(true);
        }
    };
    
    const cleanForm = () => {
        setForm({});
        setStore({});
        setZPos(45);
        setIsValid(true);
        setTabActive('create');
        setGroupUuid(false);
        setError("");
        setInitialGroup(null);
    };

    useEffect(() => {
        crmService.current = new CrmService(changeAlert);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    return {
        form,
        zPos,
        loading,
        isValid,
        tabActive,
        error,
        companyGroups,
        segments,
        storeData,
        onUpdate,
        onHandleChange,
        cleanForm,
        onCreate,
    };
};
